import angular from 'angular';

class principalKissCtrl {
    /* @ngInject */
    constructor($state, $uibModal, logger, PRINCIPAL, PrincipalSvc, AuthSvc, EMAIL_REGEXP) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.logger = logger;
        this.PRINCIPAL = PRINCIPAL;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
    }

    $onInit() {
        if (this.create || !this.principal.kiss.paramKiss) {
            this.principal.kiss.transmissionModeFtp = true;
        }
        this.resetPrincipal = angular.copy(this.principal);

        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };

        this.invitationTypes = this.PRINCIPAL.invitationType;
        this.ladTypes = this.PRINCIPAL.ladTypes;
        this.emailTemplateType = this.PRINCIPAL.emailTemplateType;
        this.langs = this.PrincipalSvc.getLangs();
        this.reportFrequencies = this.PrincipalSvc.getReportFrequencies();
        this.reportErrorFrequencies = this.getReportInvitationErrorFrequencies();
        this.invitedSellersReferentialSendingFrequencies = this.PrincipalSvc.getSellerReferentialSendingFrequencies();

        this.activateCheckboxesFlags(this.principal.kiss);

        // si creation, initialiser platformPath avec l'eid du principal.
        if (this.create && !this.principal.detail.platformPath) {
            this.principal.detail.platformPath =
                angular.lowercase(this.principal.detail.plateform) + `/${this.principal.detail.eid}`;
        }
    }

    activateCheckboxesFlags(principalKiss) {
        this.invitedSellersReferentialSendingActivation = this.isActivated(
            principalKiss.invitedSellerReferentialSendingFrequency
        );

        // répertoire spécifique pour l'export du référentiel fournisseur
        this.hasInvitedSellerSpecificDirectoryPath = !!principalKiss.invitedSellerReferentialDirectory;

        this.ladAutoReportActivation = this.isActivated(principalKiss.reportLadAutoFrequency);
        this.reportRemindersFrequencyAllowed = this.isActivated(principalKiss.reportRemindersFrequency);
    }

    isActivated(frequency) {
        return frequency !== this.PRINCIPAL.reportFrequencies[3]; // NEVER
    }

    next() {
        if (!this.form.$valid) {
            return;
        }

        const platformPathFacturX = this.principal.kiss.platformPathFacturX;
        if (!platformPathFacturX) {
            this.moveToNextStep();
            return;
        }

        this.PrincipalSvc.checkFacturXExchangeDirectoryExistence(platformPathFacturX).then(data => {
            const facturXExchangeDirectoryExist = !!data;
            if (facturXExchangeDirectoryExist) {
                this.moveToNextStep();
            } else {
                this._onNextError('FACTURX_EXCHANGE_DIRECTORY_NOT_EXIST');
            }
        });
    }

    moveToNextStep() {
        // On sauvegarde dans le service les données de création
        this.PrincipalSvc.setPrincipal(this.principal);
        // On avance d'une étape
        this.PrincipalSvc.changeCreationStep(3, 4);
        this.$state.go('app.principal.create.epdf');
    }

    _onNextError(errorDescription) {
        if (errorDescription === 'FACTURX_EXCHANGE_DIRECTORY_NOT_EXIST') {
            this.form.platformPathFacturX.$setValidity('facturxExchangeDirectoryNotExist', false);
        }
    }

    platformPathFacturXChange() {
        if (this.form.platformPathFacturX.$error.facturxExchangeDirectoryNotExist) {
            this.form.platformPathFacturX.$setValidity('facturxExchangeDirectoryNotExist', true);
        }
    }

    prev() {
        this.PrincipalSvc.setPrincipal(this.principal);
        this.PrincipalSvc.changeCreationStep(3, 2);
        this.$state.go('app.principal.create.configportal', { eid: this.principal.detail.eid });
    }

    update() {
        // TODO traiter les listes déroulantes de la lad auto
        if (!this.form.$valid) {
            return;
        }

        const platformPathFacturX = this.principal.kiss.platformPathFacturX;
        if (!platformPathFacturX) {
            this.completeUpdate();
            return;
        }

        this.PrincipalSvc.checkFacturXExchangeDirectoryExistence(platformPathFacturX).then(data => {
            const facturXExchangeDirectoryExist = !!data;
            if (facturXExchangeDirectoryExist) {
                this.completeUpdate();
            } else {
                this._onNextError('FACTURX_EXCHANGE_DIRECTORY_NOT_EXIST');
            }
        });
    }

    completeUpdate() {
        this.PrincipalSvc.updatePrincipal(this.principal).then(
            data => {
                this.form.$setPristine();
                this.logger.success('success.update', data, null, { entityName: "Le Donneur d'ordre" });
            },
            error => {
                this.logger.error('error.update', error);
            }
        );
    }

    cancel() {
        this.principal = angular.copy(this.resetPrincipal);
        this.activateCheckboxesFlags(this.principal.kiss);
    }

    isEmail(value) {
        // Regexp utilisé dans Angular pour valider les input[type=email]
        return this.EMAIL_REGEXP.test(value.text);
    }

    importTemplateEmail() {
        this.$uibModal.open({
            component: 'modalEmailInvitation',
            resolve: {
                principal: () => {
                    return this.principal;
                },
                type: () => {
                    return 'kiss';
                },
            },
        });
    }

    previewTemplateEmail(typeTemplate) {
        this.$uibModal.open({
            component: 'modalPreviewEmail',
            resolve: {
                principal: () => this.principal,
                typeTemplate: () => typeTemplate,
                langCode: () => this.langCode,
            },
            windowClass: 'app-modal-window',
        });
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    canActived() {
        return !this.principal.kiss.isEditable() || (this.principal.detail.orderEm && this.principal.kiss.paramKiss);
    }

    onLadTypeAutoChange() {
        // S'il n'y a pas de LAD Auto alors on retire aussi MyInvoice
        this.principal.kiss.ladTypeMyInvoice = this.principal.kiss.ladTypeAuto && this.principal.kiss.ladTypeMyInvoice;

        // S'il n'y a pas de LAD Auto alors on retire aussi le rapport LAD Auto
        if (!this.principal.kiss.ladTypeAuto) {
            this.ladAutoReportActivation = false;
            this.principal.kiss.reportLadAutoFrequency = this.PRINCIPAL.reportFrequencies[3]; // Never
        }
    }

    isTransmissionModeRequired() {
        return (
            !this.principal.kiss.transmissionModeMail &&
            !this.principal.kiss.transmissionModeFtp &&
            this.principal.kiss.paramKiss
        );
    }

    onInvitedSellerReferentialSendingActivationChange(isChecked) {
        if (isChecked) {
            this.openSSPWarning().result.then(
                () => {
                    this.principal.kiss.invitedSellerReferentialSendingFrequency = this.PRINCIPAL.reportFrequencies[0];
                },
                () => {
                    this.invitedSellersReferentialSendingActivation = false;
                    this.principal.kiss.invitedSellerReferentialSendingFrequency = this.PRINCIPAL.reportFrequencies[3];
                }
            );
        } else {
            this.principal.kiss.invitedSellerReferentialSendingFrequency = this.PRINCIPAL.reportFrequencies[3];

            // reset du chemin du répertoire spécifique pour l'export du référentiel fournisseur
            this.hasInvitedSellerSpecificDirectoryPath = false;
            this.principal.kiss.invitedSellerReferentialDirectory = '';
        }
    }

    onInvitedSellerSpecialTraitementActivationChange() {
        if (!this.hasInvitedSellerSpecificDirectoryPath) {
            this.principal.kiss.invitedSellerReferentialDirectory = '';
        }
    }

    openSSPWarning() {
        return this.$uibModal.open({
            component: 'confirmationModal',
            resolve: {
                modalMessage: () => {
                    return [{ key: 'principal.kiss.ssp_warning' }];
                },
            },
            backdrop: 'static',
            keyboard: false,
        });
    }

    onSelfBillingChange() {
        this.principal.kiss.invitationType = this.invitationTypes[0];
        this.reportErrorFrequencies = this.getReportInvitationErrorFrequencies();
        if (this.principal.kiss.selfBilling) {
            this.principal.kiss.reportUsageFrequency = this.reportFrequencies[3];
            this.principal.kiss.reportRemindersFrequency = this.reportFrequencies[3];
            this.principal.kiss.invitationType = this.invitationTypes[0];
            this.principal.kiss.ladTypeAuto = false;
            this.principal.kiss.ladTypeExtern = false;
            this.principal.kiss.ladTypeMyInvoice = false;
        }
        this.setReportInvFlyErrorFrequency();
    }

    disableSelfBillingSelection() {
        return (
            !this.principal.kiss.paramKiss ||
            (!this.principal.kiss.selfBilling && this.principal.kiss.hasSellerWithValidBusinessRelationship)
        );
    }

    getReportInvitationErrorFrequencies() {
        return this.principal.kiss.selfBilling
            ? this.PrincipalSvc.getInvitationReportErrorFrequencies()
            : this.PrincipalSvc.getReportFrequencies();
    }

    setReportInvFlyErrorFrequency() {
        if (this.create) {
            this.principal.kiss.reportInvFlyErrorFrequency = this.principal.kiss.selfBilling
                ? this.reportFrequencies[1]
                : this.reportFrequencies[3];
        } else {
            this.principal.kiss.reportInvFlyErrorFrequency =
                this.principal.kiss.selfBilling &&
                this.principal.kiss.reportInvFlyErrorFrequency === this.reportFrequencies[3]
                    ? this.reportFrequencies[1]
                    : this.principal.kiss.reportInvFlyErrorFrequency;
        }
    }

    resetReportRemindersFrequencyIfNeeded() {
        if (!this.reportRemindersFrequencyAllowed) {
            this.principal.kiss.reportRemindersFrequency = this.PRINCIPAL.reportFrequencies[3];
        }
    }
}

angular.module('app.principal').component('principalKiss', {
    templateUrl: require('./principal-kiss.html'),
    controller: principalKissCtrl,
    bindings: {
        countries: '<',
        ladProviders: '<',
        principal: '<',
        create: '<',
    },
});
